export default __webpack_public_path__ + "static/media/pothos.4024f763.gif";